'use client';

import { c as _c } from "react/compiler-runtime";
import type { GraphQLDeparture } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { useDepartureSummary } from '@sola/supporter-sdk/hooks/commitments.ts';
import type { DepartureAlertPageData } from './departure-alert-page-alert.ts';
export type DepartureAlertData = DepartureAlertPageData;
export const getDepartureAlertData = (departures: GraphQLDeparture[], globalId: string): DepartureAlertData | undefined => {
  const departure = departures.find(({
    departedChild
  }) => departedChild.globalId === globalId);
  const childName = (departure?.departedChild.displayName ?? '').trim();
  if (!childName) {
    return;
  }
  if (departure?.sub?.shouldDisplay === true && departure.sub.completed === false) {
    return {
      variant: 'sub',
      departedChildName: childName,
      count: 1
    };
  }
  return {
    variant: 'departure',
    childName,
    count: 1
  };
};
export const useDepartureAlert = globalId => {
  const $ = _c(5);
  const departureSummaryQuery = useDepartureSummary();
  const isLoading = departureSummaryQuery.isLoading || departureSummaryQuery.isFetching || departureSummaryQuery.isPending;
  if (isLoading || departureSummaryQuery.isError) {
    return;
  }
  let t0;
  if ($[0] !== departureSummaryQuery.departureSummary?.departures) {
    t0 = departureSummaryQuery.departureSummary?.departures ?? [];
    $[0] = departureSummaryQuery.departureSummary?.departures;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== globalId || $[3] !== t0) {
    t1 = getDepartureAlertData(t0, globalId);
    $[2] = globalId;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};